import { Box, Flex, Text } from "@100mslive/react-ui";
import React, { useContext } from "react";

import Countdown from "react-countdown";
import { LiveHodoContext } from "../contexts/LiveHodoContext";
import { ShieldAlertIcon } from "@100mslive/react-icons";

const CountdownBox = ({ value, label }) => {
  return (
    <Box
      css={{
        backgroundColor: "$surfaceDefault",
        border: "1px solid $borderLight",
        borderRadius: "$4",
        padding: "$8",
        textAlign: "center",
      }}
    >
      <Box css={{ fontSize: "$h6" }}>{value > 9 ? value : `0${value}`}</Box>
      <Box>{label}</Box>
    </Box>
  );
};

export const NonPublisherView = React.memo(
  ({ message, hasPublishingPeers, upcomingEvents }) => {
    const {
      stateCtx: { circleRoomDetail },
    } = useContext(LiveHodoContext);
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
      if (completed) {
        return <></>;
      } else {
        return (
          <Flex
            justify="center"
            css={{
              gap: "$10",
            }}
          >
            {days > 0 && <CountdownBox value={days} label={`Ngày`} />}
            <CountdownBox value={hours} label={`Giờ`} />
            <CountdownBox value={minutes} label={`Phút`} />
            <CountdownBox value={seconds} label={`Giây`} />
          </Flex>
        );
      }
    };

    return (
      <Box
        css={{
          position: "relative",
          overflow: "hidden",
          w: "96%",
          maxWidth: "96%",
          h: "100%",
          m: "auto",
          backgroundColor: "$surfaceDefault",
          backgroundImage: circleRoomDetail?.background
            ? `url(${circleRoomDetail?.background})`
            : "",
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: "$3",
          "&::before": {
            content: "",
            display: circleRoomDetail?.background ? "block" : "none",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            backgroundColor: "$statsBg",
          },
        }}
        data-testid="non_publisher_view"
      >
        <Flex
          align="center"
          direction="column"
          css={{
            position: "relative",
            w: "100%",
            textAlign: "center",
            margin: "auto",
            h: "100%",
            justifyContent: "center",
            gap: "$8",
          }}
        >
          <ShieldAlertIcon color="#C3D0E5" width="80px" height="80px" />
          <Flex
            direction="column"
            css={{
              w: "100%",
              p: "$1",
              gap: "$4",
            }}
          >
            <Text
              color="white"
              variant="h6"
              css={{ "@md": { fontSize: "$md" }, whiteSpace: "pre-line" }}
            >
              {message}
            </Text>
            {!hasPublishingPeers && upcomingEvents?.schedule_date && (
              <Box
                css={{
                  color: "white",
                  marginTop: "$4",
                }}
              >
                <Countdown
                  date={upcomingEvents?.schedule_date}
                  renderer={renderer}
                />
              </Box>
            )}
            {/* <Text
            color="$textMedEmp"
            css={{ mt: "$4", "@md": { fontSize: "$sm" } }}
          >
            Please go to dashboard and reconfigure role settings or contact the
            role admin.
          </Text> */}
          </Flex>
        </Flex>
      </Box>
    );
  }
);
